import successImg from '@shared/Modals/SupportModal/assets/successRequest.png';

export const helpFormTranslates = {
  successScreen: {
    ru: {
      description:
        'Спасибо! Мы рассмотрим ваше обращение в самое ближайшее время',
      title: 'Ваше обращение отправлено',
      image: {
        url: successImg.src,
      },
    },
    en: {
      description: 'Thanks! We will consider your request as soon as possible',
      title: 'Your request has been sent',
      image: {
        url: successImg.src,
      },
    },
    zh: {
      description: '谢谢您！ 我们会尽快考虑您的请求',
      title: '您的申请已经提交',
      image: {
        url: successImg.src,
      },
    },
  },
  title: {
    ru: 'Обратиться в поддержку',
    en: 'Write to support',
    zh: '联系支持',
  },
};
